<template>
  <div class="relative flex flex-col bg-gray-900 rounded-xl p-4 text-sm text-white w-1/4"
       :class="{'border-2 border-green-500' : order.backColor === 'Green'}"
       @touchstart="toggleAnimation($event)" @touchend="toggleAnimation">

    <div class="absolute -top-10 flex justify-center w-full">
      <div class="text-xl bg-gray-900 rounded-2xl p-3 ml-8"
           :class="{'border-t-2 border-green-500' : order.backColor === 'Green'}">{{ order.TableNo }}
      </div>
    </div>

    <div class="grid grid-cols-2">
        <span class="flex">
          <UserIcon class="w-5 h-5 text-yellow-300"/>
          <span class="mr-1">{{ order.create_USER }}</span>
        </span>
      <span class="flex mr-4">
          <ClockIcon class="h-5 w-5 text-yellow-300"/>
          <span class="mr-1">{{ order.CreateTime }}</span>
        </span>
    </div>

    <div class="grid grid-cols-2 mt-3">
        <span class="flex items-center">
            <UserGroupIcon class="h-5 w-5 text-yellow-300"/>
            <span class="mr-1 font-bold">{{ order.CustomerName }}</span>
          </span>
      <span class="flex mr-4">
          <InformationCircleIcon class="h-5 w-5 text-yellow-300"/>
          <span class="mr-1">{{ order.desC_COOK }}</span>
        </span>
    </div>

    <div class="mt-4">
        <span class="flex">
          <DocumentTextIcon class="h-5 w-5 text-yellow-300"/>
          <span class="mr-1">{{ order.Description }}</span>
        </span>
    </div>

    <div class="bg-gray-800 rounded-lg p-4 my-4">
      <table class="w-full divide-y divide-gray-400">
        <thead>
        <tr class="text-xs">
          <td>نام</td>
          <td class="pr-2">تعداد</td>
          <td class="pr-2">بیرون</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="food in order.v_Monitoring_Ashpazkhane_Details" :key="food.id">
          <td class="py-2">{{ food.KalaName }}</td>
          <td class="text-center text-green-400">{{ food.RequestQty }}</td>
          <td class="text-center">{{ food.TAKEOUTNUM }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="flex mt-auto items-center">
      <span class="w-full text-green-300 cursor-pointer" @click="loadFactorDetail">{{ order.otherMonitorNotif }}</span>
      <div class="w-full">
        <Button @click="goToPreviousState" v-if="previousState.name">{{ previousState.name }}</Button>
        <Button @click="checkNextState" class="mt-2" v-if="nextState.name">{{ nextState.name }}</Button>
      </div>
    </div>
  </div>

  <VModal
      title="انتخاب غذابر"
      :show="deliveryBoyModal"
      @click="deliveryBoyModal = false">
    <div class="p-4">
      <select class="w-full p-2 rounded bg-gray-800 text-white" v-model="deliveryBoy">
        <option value="" disabled>انتخاب غذابر</option>
        <option v-for="boy in deliveryBoys"
                :key="boy.Code"
                :value="boy.Code">
          {{ boy.Name }}
        </option>
      </select>

      <Button class="mt-4" @click="goToNextState">ثبت</Button>
    </div>
  </VModal>

  <VModal
      :show="detailModal"
      title="جزئیات فاکتور"
      @click="detailModal = false">
    <table class="w-full text-white">
      <thead>
      <tr>
        <td>نام</td>
        <td>شرح</td>
      </tr>
      </thead>
      <tbody class="divide-y">
      <tr
      v-for="detail in details"
      :key="detail">
        <td class="py-4">{{ detail.kalaName }}</td>
        <td>{{ detail.kalaDetail || '-' }}</td>
      </tr>
      </tbody>
    </table>
  </VModal>
</template>

<script>
import {ClockIcon, DocumentTextIcon, InformationCircleIcon, UserGroupIcon, UserIcon} from "@heroicons/vue/outline";
import Button from "../General/Button";
import {changeOrderState, getDeliveryBoyList, getFactorExtraItems} from "../../API/API";
import VModal from "../General/VModal";

export default {
  name: "MonitorOrder",
  emits: ['update'],
  props: ['order', 'states', 'monitorId', 'isDetailEnable'],
  components: {
    VModal,
    Button,
    UserIcon,
    ClockIcon,
    DocumentTextIcon,
    UserGroupIcon,
    InformationCircleIcon,
  },
  data() {
    return {
      previousState: {
        id: '',
        name: ''
      },
      nextState: {
        id: '',
        name: ''
      },
      deliveryBoys: [],
      deliveryBoyModal: false,
      deliveryBoy: '',

      deliveryTimeModal: false,
      deliveryTime: '',

      detailModal: false,
      details: []
    }
  },
  async created() {
    this.deliveryBoys = (await getDeliveryBoyList(this.monitorId)).data.result
    this.getStateData();
  },
  methods: {
    getStateData() {
      let state = this.states.find(state => state.id == this.order.status)
      this.previousState = state.beforState
      this.nextState = state.afterState
    },
    checkNextState() {
      if (this.nextState.isEnableDeliveryBoy) {
        this.deliveryBoyModal = true
      } else if (this.nextState.isEnableTime) {
        this.deliveryTimeModal = true
      } else {
        this.goToNextState()
      }
    },
    goToNextState() {
      this.deliveryBoyModal = false
      this.deliveryTimeModal = false
      changeOrderState(this.order, this.monitorId, this.nextState.id, this.order.status, this.deliveryBoy, this.deliveryTime)
      this.$emit('update')
    },
    goToPreviousState() {
      changeOrderState(this.order, this.monitorId, this.previousState.id, this.order.status)
      this.$emit('update')
    },
    async loadFactorDetail() {
      if (this.isDetailEnable) {
        this.detailModal = true
        this.details = (await getFactorExtraItems(this.order.Id)).data.result
      }
    }
  },
}
</script>

<style scoped>

</style>